import React, { useState } from 'react';
import { MdClose } from 'react-icons/md'
import styled, { createGlobalStyle, keyframes } from 'styled-components'


export default ({ onClose, bubbles }) => {
    
    const designCentre = bubbles.find(bubble => bubble.label === 'Design Centre')
    const researchCentre = bubbles.find(bubble => bubble.label === 'Research Centre')
    const businessCentre = bubbles.find(bubble => bubble.label === 'Business Centre')
    const ucuCentre = bubbles.find(bubble => bubble.label === 'UCU')
    const library = bubbles.find(bubble => bubble.label === 'The Library')
    const radio = bubbles.find(bubble => bubble.label === 'UserCity Radio')
    const townHall = bubbles.find(bubble => bubble.label === 'Town Hall')
    const wellnessCentre = bubbles.find(bubble => bubble.label === 'Wellness Centre')
    const nucleus = bubbles.find(bubble => bubble.label === 'Nucleus')
    const projectHub = bubbles.find(bubble => bubble.label === 'Project Hub')
    const collaborationCentre = bubbles.find(bubble => bubble.label === 'Collaboration Centre')
    
    const [ closeDirection, setCloseDirection ] = useState(false);

    return (
        <Style>
            <button className="modal__close" type={'button'} onClick={onClose}><MdClose /></button>

            <div className="modal__inner">
                <figure>
                    {closeDirection === false && <span className="modal__direction">Hover over a building to find out more <button type="button" onClick={() => setCloseDirection(true)}><MdClose /></button></span>}
                    <picture>
                        <source srcSet={'/cityscape.webp'} type="image/webp" />
                        <img src="/cityscape.png" alt="cityscape" width={1352} height={802} />
                    </picture>
                    <ul>
                        {designCentre && <li data-precinct="design-centre">
                            <button type="button">{designCentre.label}</button>
                            <div>
                                <h3>{designCentre.label}</h3>
                                <p>{designCentre.body}</p>
                            </div>
                        </li>}
                        {researchCentre && <li data-precinct="research-centre">
                            <button type="button">{researchCentre.label}</button>
                            <div>
                                <h3>{researchCentre.label}</h3>
                                <p>{researchCentre.body}</p>
                            </div>
                        </li>}
                        {businessCentre && <li data-precinct="business-centre">
                            <button type="button">{businessCentre.label}</button>
                            <div>
                                <h3>{businessCentre.label}</h3>
                                <p>{businessCentre.body}</p>
                            </div>
                        </li>}
                        {ucuCentre && <li data-precinct="ucu">
                            <button type="button">{ucuCentre.label}</button>
                            <div>
                                <h3>{ucuCentre.label}</h3>
                                <p>{ucuCentre.body}</p>
                            </div>
                        </li>}
                        {library && <li data-precinct="library">
                            <button type="button">{library.label}</button>
                            <div>
                                <h3>{library.label}</h3>
                                <p>{library.body}</p>
                            </div>
                        </li>}
                        {radio && <li data-precinct="radio">
                            <button type="button">{radio.label}</button>
                            <div>
                                <h3>{radio.label}</h3>
                                <p>{radio.body}</p>
                            </div>
                        </li>}
                        {townHall && <li data-precinct="town-hall">
                            <button type="button">{townHall.label}</button>
                            <div>
                                <h3>{townHall.label}</h3>
                                <p>{townHall.body}</p>
                            </div>
                        </li>}
                        {wellnessCentre && <li data-precinct="wellness-centre">
                            <button type="button">{wellnessCentre.label}</button>
                            <div>
                                <h3>{wellnessCentre.label}</h3>
                                <p>{wellnessCentre.body}</p>
                            </div>
                        </li>}
                        {nucleus && <li data-precinct="nucleus">
                            <button type="button">{nucleus.label}</button>
                            <div>
                                <h3>{nucleus.label}</h3>
                                <p>{nucleus.body}</p>
                            </div>
                        </li>}
                        {projectHub && <li data-precinct="project-hub">
                            <button type="button">{projectHub.label}</button>
                            <div>
                                <h3>{projectHub.label}</h3>
                                <p>{projectHub.body}</p>
                            </div>
                        </li>}
                        {collaborationCentre && <li data-precinct="collaboration-centre">
                            <button type="button">{collaborationCentre.label}</button>
                            <div>
                                <h3>{collaborationCentre.label}</h3>
                                <p>{collaborationCentre.body}</p>
                            </div>
                        </li>}

                        
                        
                        
                    </ul>
                </figure>
            </div>
        </Style>
    )
}


const Style = styled.div.attrs(props => ({

}))`
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    background-color: rgba(255,255,255,.95);
    height: 100%;
    z-index: 500;
    animation-name: ${keyframes`
        0% {
            opacity: 0;
        }
        100% {
            opacity: 1;
        }
    `};
    animation-duration: .3s;
    animation-fill-mode: forwards;
    animation-iteration-count: 1;

    .modal__inner {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 100%;
    }

    .modal__direction {
        position: absolute;
        left: 50%;
        top: -2vh;
        transform: translateX(-50%);
        z-index: 1;
        background-color: rgb(112, 112, 112);
        color: white;
        border-radius: 3px;
        padding: .8em 1em .5em 1em;
        font-size: 14px;
        font-weight: 600;
        line-height: 1;
        display: flex;
        align-items: center;
        opacity: 0;
        box-shadow: 0 0 1vw rgba(0,0,0,.15);
        animation-name: ${keyframes`
            0% {
                opacity: 0;
            }
            10% {
                opacity: 1;
            }
            90% {
                opacity: 1;
            }
            100% {
                opacity: 0;
            }
        `};
        animation-duration: 5s;
        animation-delay: .5s;
        animation-iteration-count: 1;
        animation-fill-mode: forwards;

        button {
            background-color: transparent;
            padding: 0;
            appearance: none;
            outline: none;
            border: none;
            margin-left: 4em;
            cursor: pointer;

            svg {
                color: white;
                width: 1.5em;
                height: 1.5em;
            }
        }
    }

    figure, img {
        margin: 0;
    }

    img {
        width: 100%;
        height: auto;
        max-height: 100%;
    }

    figure {
        max-width: 80vw;
        max-height: 80vh;
        position:relative;
    
        ul {
            list-style: none;
            padding: 0;
            margin:0;

            > li {
                position: absolute;
                z-index: 11;
                margin-bottom: 0;

                button {
                    height: 100%;
                    background-color: transparent;
                    border: none;
                    cursor: pointer;
                    text-indent: -5000em;
                    display: block;
                    white-space: nowrap;
                    z-index:100;
                    position: relative;
                    outline: none;
                }

                > div {
                    background: white;
                    padding: 1.25em;
                    border: 1px solid rgba(0,0,0,.25);
                    box-shadow: 0 0 1vw rgba(0,0,0,.3);
                    opacity: 0;
                    transition: opacity .3s ease, transform .3s ease;
                    top: 0;
                    min-width: 295px;
                    font-size: 14px;
                    z-index: 0;
                    width:0;
                    max-height: 0;
                    cursor: default;
                    visibility: hidden;

                    h3 {
                        margin: 0 0 .25em 0;
                        letter-spacing: -.035em;
                    }

                    &::after {
                        content: '';
                        position: absolute;
                        width: 0px;
                        height: 0px;
                        border-top: 15px solid white;
                        border-right: 15px solid transparent;
                        border-bottom: 15px solid transparent;
                        border-left: 15px solid transparent;
                        bottom:0;
                        left: 2em;
                        transform: translateY(100%);
                    }
                }

                button:hover + div {
                    opacity: 1;
                    //z-index: 10;
                    position: absolute;
                    width: 100%;
                    max-height: inherit;
                    visibility: visible;
                }
            }

            li[data-precinct="design-centre"] {
                top: 39%;
                left: 15%;
                height: 5vw;
                
                button {
                    width: 6.5vw;
                }

                > div {
                    transform: translateY(-90%) translateX(10%);
                }

                button:hover + div {
                    transform: translateY(-100%) translateX(10%);
                }
            }

            li[data-precinct="research-centre"] {
                top: 50%;
                left: 0%;
                height: 7vw;

                button {
                    width: 13.5vw;
                }
                > div {
                    transform: translateY(-90%) translateX(10%);
                }

                button:hover + div {
                    transform: translateY(-100%) translateX(10%);
                }
            }

            li[data-precinct="business-centre"] {
                top: 10%;
                left: 14%;
                height: 12vw;

                button {
                    width: 7.5vw;
                }
                > div {
                    transform: translateY(-70%) translateX(10%);
                }

                button:hover + div {
                    transform: translateY(-80%) translateX(10%);
                }
            }

            li[data-precinct="ucu"] {
                top: 65%;
                left: 10%;
                height: 12vw;

                button {
                    width: 19.5vw;
                }
                > div {
                    transform: translateY(-50%) translateX(40%);
                }

                button:hover + div {
                    transform: translateY(-60%) translateX(40%);
                }
            }

            li[data-precinct="library"] {
                top: 74%;
                left: 29%;
                height: 9vw;

                button {
                    width: 11vw;
                }
                > div {
                    transform: translateY(-70%) translateX(10%);
                }

                button:hover + div {
                    transform: translateY(-80%) translateX(10%);
                }
            }

            li[data-precinct="radio"] {
                top: 4%;
                left: 43%;
                height: 10vw;

                button {
                    width: 6vw;
                }
                > div {
                    transform: translateY(-60%) translateX(0%);
                }

                button:hover + div {
                    transform: translateY(-70%) translateX(0%);
                }
            }

            li[data-precinct="town-hall"] {
                top: 28%;
                left: 82%;
                height: 10vw;

                button {
                    width: 9vw;
                }
                > div {
                    transform: translateY(-70%) translateX(-10%);
                }

                button:hover + div {
                    transform: translateY(-80%) translateX(-10%);
                }
            }

            li[data-precinct="wellness-centre"] {
                top: 52%;
                left: 34%;
                height: 10vw;

                button {
                    width: 9vw;
                }
                > div {
                    transform: translateY(-50%) translateX(10%);
                }

                button:hover + div {
                    transform: translateY(-60%) translateX(10%);
                }
            }
            li[data-precinct="nucleus"] {
                top: 75%;
                left: 70%;
                height: 7vw;

                button {
                    width: 9vw;
                }
                > div {
                    transform: translateY(-50%) translateX(10%);
                }

                button:hover + div {
                    transform: translateY(-60%) translateX(10%);
                }
            }
            li[data-precinct="project-hub"] {
                top: 35%;
                left: 52%;
                height: 10vw;

                button {
                    width: 11vw;
                }
                > div {
                    transform: translateY(-80%) translateX(20%);
                }

                button:hover + div {
                    transform: translateY(-90%) translateX(20%);
                }
            }
            li[data-precinct="collaboration-centre"] {
                top: 15%;
                left: 55%;
                height: 6vw;

                button {
                    width: 8vw;
                }
                > div {
                    transform: translateY(-80%) translateX(20%);
                }

                button:hover + div {
                    transform: translateY(-90%) translateX(20%);
                }
            }

            

            
            
        }
    }


    .modal__close {
        position: absolute;
        top: 2vw;
        right: 2vw;
        padding: 0;
        background-color: transparent;
        border: none;
        cursor: pointer;
        outline: none;

        svg {
            min-width: 30px;
            min-height:30px;
        }
    }
`